import { useState } from 'react'
import toast from 'react-hot-toast'
import MainButton from '../../../components/buttons/mainButton/MainButton'
import { translations } from '../../../configs/translations'
import { VehicleService } from '../../../services/VehicleService'
import { useStore } from '../../../store/store'
import { FineTuningCache } from '../FineTuning.cache'
import { FineTuningComponentData, FineTuningPutRequest } from '../FineTuning.types'
import './FineTuningComponent.css'
import { FineTuningSettingCategory } from './fineTuningSettingCategory/FineTuningSettingCategory'
import { FineTuningComponentProfiles } from './fineTuningSettingCategory/fineTuningComponentProfiles/FineTuningComponentProfiles'

export const FineTuningComponent = ({
	profile,
	setSelectedProfile,
	component,
	setFineTuningSettingsRef
}: {
	profile: string,
	setSelectedProfile: (profile: string) => void,
	component: FineTuningComponentData,
	setFineTuningSettingsRef: React.Dispatch<React.SetStateAction<number>>
}) => {

	const [activeSetting, setActiveSetting] = useState<string | undefined>(undefined)
	const language = useStore(state => state.language)
	const t = translations[language]

	const save = async () => {
		const cache = FineTuningCache.getInstance().getCache()
		if (!cache) {
			toast.error(
				t.error_unknown,
				{ className: 'notification-error' }
			)
			return
		}
		const cacheProfile = FineTuningCache.getInstance().getProfileByName(profile, cache)
		const request = {
			vehicleId: Number(cache.vehicleId),
			profile: profile.toUpperCase(),
			aerodynamicProfile: cacheProfile?.aerodynamicProfile,
			castor: cacheProfile?.castor,
			downpipe: cacheProfile?.downpipe,
			frontCamber: cacheProfile?.frontCamber,
			rearCamber: cacheProfile?.rearCamber,
			frontToe: cacheProfile?.frontToe,
			rearToe: cacheProfile?.rearToe,
			clearance: cacheProfile?.clearanceChange,
			frontTrackWidth: cacheProfile?.frontTrackWidth,
			rearTrackWidth: cacheProfile?.rearTrackWidth,
			steeringLock: cacheProfile?.steeringLock,
			slipAngle: cacheProfile?.slipAngle
		} as FineTuningPutRequest
		if (!request) {
			toast.error(
				t.error_unknown,
				{ className: 'notification-error' }
			)
			return
		}
		if (!FineTuningCache.getInstance().hasChanges(profile)) {
			toast.error(t.error_no_changes, { className: 'notification-error' })
			return
		}
		await VehicleService.storeFineTuningSettings(request)
			.then(() => {
				toast.success(t.success_save)
				FineTuningCache.getInstance().updateInitialCache(cache)
			})
			.catch((error) => {
				toast.error(
					error && error.response && error.response.data && t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}

	return (
		<div className='fine-tuning-component-wrapper'>
			<FineTuningComponentProfiles profile={profile} setSelectedProfile={setSelectedProfile} />

			<div className={`fine-tuning-component ${profile}`}>
				<div className={`fine-tuning-component-header ${profile}`}>
					<h1 className='fine-tuning-component-header-h1'>{t[component.translation as keyof typeof t]}</h1>
				</div>

				<div className='fine-tuning-component-body'>
					{
						component.settingCategories.map((settingCategory, categoryIndex) => (
							<FineTuningSettingCategory
								categoryIndex={categoryIndex}
								name={settingCategory.name}
								activeSetting={activeSetting}
								setActiveSetting={setActiveSetting}
								category={settingCategory}
								setFineTuningSettingsRef={setFineTuningSettingsRef}
								profileName={profile}
								activeComponent={component.name}
							/>
						))
					}
				</div>

				<div className='fine-tuning-componennt-footer'>
					<MainButton
						text={t.save}
						type='submit'
						buttonStyles={{ width: '200px' }}
						onClick={save}
					/>
				</div>
			</div>
		</div>
	)
}